import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal, selectStandard } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { dataSorting, findKeyBaseOnValue, formatTypeAheadOptions } from '../../ModificationsUtils';

interface PayerProps {
  readOnly?: boolean;
}

export const Payer = ({ readOnly }: PayerProps) => {
  const { control, getValues, setValue, clearErrors, setError, register } = useFormContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);
  const payer = 'payer';
  register('payerId');
  const isModEdit = useSelector(selectIsEditMod);
  const standard = useSelector(selectStandard);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });

  const [payerOptions, setPayerOptions] = useState([]);

  const getPayerDropDown = async () => {
    const options = await getSearchFilterOptions('payer');

    if (options?.length > 0) {
      const newOptions = formatTypeAheadOptions(options);
      setPayerOptions(newOptions);

      if (getValues(payer)) {
        const selectedOption = findKeyBaseOnValue(newOptions, getValues(payer));

        setValue('payerId', selectedOption?.id);
        clearErrors(payer);
      } else {
        setError(payer, {});
      }
      if (isUndoModal) {
        dispatch(placementModsAction.setIsUndoModal(false));
      }
    }
  };

  const getPayerId = (value: string) => {
    const selectedOption = findKeyBaseOnValue(payerOptions, value);
    return selectedOption?.id;
  };

  const handleChange = (value?: string) => {
    setValue(payer, value);
    setValue('payerId', getPayerId(value));
    if (value) {
      clearErrors(payer);
    }
  };

  useEffect(() => {
    getPayerDropDown();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);

  return (
    <Controller
      control={control}
      name={payer}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value, ...rest } }) => {
        return (
          <FormInputDropdown
            useMenuItem={true}
            name={payer}
            label={t('placement.placementMods.payer')}
            standard={true}
            options={dataSorting(payerOptions) ?? []}
            handleChange={e => {
              handleChange(e.target.value);
              onChange(e.target.value);
            }}
            {...rest}
            inputValue={getValues(payer) ?? ''}
            readOnly={readOnly !== undefined ? readOnly : (standard ? standard : !isModEdit)}
            disabled={isSaveModApiCalling}
          ></FormInputDropdown>
        );
      }}
    />
  );
};
